if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');

      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this.hideErrors = false; //this.dataset.hideErrors === 'true';
    }

    async onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const id = this.form.querySelector('[name=id]').value;
      const quantity = parseInt(document.querySelector('[data-cart-quantity]').value) || 1;

      const dataUrl = this.submitButton.getAttribute('data-url');

      let props = {};
      let iterationCount = 0;
      function recursiveLoop() {
          document.querySelectorAll('.variantlistbox')?.forEach((e) => {
            if (e.querySelector('option')?.innerHTML.includes('Default')) {
              e.style.display = "none";
              return
            }
          });
          iterationCount++;
        
          if (iterationCount < 20) {
            setTimeout(recursiveLoop, 1000);
          }
        }
      recursiveLoop();

         function recursiveSizeLoop() {
          document.querySelectorAll('.variantlistbox')?.forEach((e) => {
            document.querySelectorAll('.variant__input').forEach((each)=>{
                each.querySelectorAll('option').forEach((ele)=>{
                    if(each.getAttribute('identifier')==ele.value){
                      ele.setAttribute('selected', 'selected');
                      return;
                    }
                })
            })
            
          });
          iterationCount++;
        
          if (iterationCount < 20) {
            setTimeout(recursiveSizeLoop, 1000);
          }
        }
      recursiveSizeLoop();
      

      if (window.location.href.indexOf("physical-gift-card") > -1 || dataUrl == "physical-gift-card") {
        var card_msg = document.getElementById('gift-card-message').value;
        props = {
          "SAY SOMETHING SWEET": card_msg
        };
      }

      const recipientForm = this.querySelector('recipient-form'); //for digital gift cards
      if(recipientForm && recipientForm.querySelector('[name="properties[__shopify_send_gift_card_to_recipient]"]').checked) {
        let formProperties = recipientForm.querySelectorAll('[name^="properties["]');
        formProperties.forEach((field) => {
          if(field.value !== '' && !field.disabled) {
            let propertyName = field.name.replace('properties[', '').replace(']', '')
            props[propertyName] = field.value;
          }
        })
      }

      //preorder check
      if(this.querySelector('#preorder')){
        const preorderIds = (!!this.form.dataset.preorderVariantIds) ? this.form.dataset.preorderVariantIds.split(",") : [];
        if(preorderIds.includes(id+"")){
          props["Preorder"] = "Preorder";
        }
      }

        await window.theme.addToCart({
        id,
        quantity: quantity || 0,
        properties: props,
      })
        .then((result) => {
          if (result.error) {
            this.handleErrorMessage(result.error);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            soldOutMessage.textContent = result.error;
            this.error = true;
            return
          }
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            quickAddModal.hide(true);
          }
        }).finally(() => {
          this.submitButton.classList.remove('loading');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });




    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
